export const MAX_AI_FORM_ASSIST_MESSAGE_LENGTH = 50_000;
